import { Component, inject } from '@angular/core';
import { InternalAuthService, UtilityService } from '@eforall/common';
import { AppDataService, StaticDataService } from 'services';
import { DashboardPageService } from '../dashboard.page.service';


@Component({
	selector: 'quick-filters-panel-part',
	imports: [],
	templateUrl: './quick-filters-panel.part.html',
	styleUrl: './quick-filters-panel.part.scss',
})
export class QuickFiltersPanelPart {

	private auth = inject(InternalAuthService);
	private appData = inject(AppDataService);
	private staticData = inject(StaticDataService);
	private util = inject(UtilityService);
	public pageService = inject(DashboardPageService);

}
